export const ResignVI = {
  "reasonResign": {

    "column": {
      "name": "Phương tiện"
    },
    "title": "Lý do nghỉ việc",
    "breadCrumb": "Quản lý lý do nghỉ việc",
    "pageHeader": {
      "reasonResign": "Quản lý lý do nghỉ việc"
    }
  }
}
